import * as aor from "react-admin";
import React from "react";
import MyChipField from "../../components/MyChipField";
import { POLICY_TICKETS } from "../../common/rolesManagement";
import StatusChip from "../../components/StatusChip";
import { TicketEventStatus } from "../../common/statuses";
import Cloud from "@material-ui/icons/Cloud";
import CloudUpload from "@material-ui/icons/CloudUpload";
import Tooltip from "@material-ui/core/Tooltip";
import TranslatedText from "../../components/TranslatedText";
import { getPolicies } from "../../common/authClient";

const statusFilterChoices = Object.values(TicketEventStatus).map(status => ({
    id: status,
    name: `resources.tickets.status.${status}`
}));
const MyActivityField = props => {
    const { record } = props;
    if (record && record.activity !== undefined) {
        const activity_resource_name = `resources.tickets.activity_decoder.${record.activity}`;
        let image = <CloudUpload />;
        if (record.activity !== "MIGRATION") {
            image = <Cloud />;
        }
        return (
            <Tooltip
                title={
                    <TranslatedText resource_name={activity_resource_name} />
                }
            >
                {image}
            </Tooltip>
        );
    }
};

const getTypes = props => {
    if (Object.values(props.data)[0]) {
        let dati = Object.values(props.data)[0];
        let arr = dati["result_lic"];
        if (arr && Object.keys(arr).length !== 0) {
            return arr.map(installation_type => ({
                id: installation_type.id,
                name: installation_type.name
            }));
        }
    }
};

const Filter = props => (
    <aor.Filter {...props}>
        <aor.SelectInput
            source="status"
            choices={statusFilterChoices}
            alwaysOn={true}
            allowEmpty={false}
        />
        <aor.SelectInput
            source="installation_type_id"
            choices={getTypes(props)}
            alwaysOn={true}
            allowEmpty={true}
        />
        <aor.SelectInput
            source="activity"
            choices={[
                { id: "INSTALLATION", name: "NUOVA INSTALLAZIONE" },
                { id: "MIGRATION", name: "MIGRAZIONE" }
            ]}
            alwaysOn={true}
            allowEmpty={
                getPolicies() &&
                !getPolicies().includes(POLICY_TICKETS.SAFE_CREATE)
            }
        />
        {getPolicies() &&
            !getPolicies().includes(POLICY_TICKETS.SAFE_CREATE) && (
                <aor.TextInput
                    label="resources.tickets.fields.company_id"
                    source="company_name"
                    alwaysOn={true}
                />
            )}
        <aor.TextInput
            label="resources.tickets.fields.customer_id"
            source="customer_name"
            alwaysOn={true}
        />
        {getPolicies() &&
            !getPolicies().includes(POLICY_TICKETS.SAFE_CREATE) && (
                <aor.TextInput
                    label="resources.tickets.fields.user_id"
                    source="user_name"
                    alwaysOn={true}
                />
            )}
    </aor.Filter>
);

const RolesActions = ({ basePath, _ }) => (
    <aor.CardActions
        style={{ zIndex: 2, display: "inline-block", float: "right" }}
    >
        {getPolicies() &&
            (getPolicies().includes(POLICY_TICKETS.CREATE) ||
                getPolicies().includes(POLICY_TICKETS.SAFE_CREATE)) && (
                <aor.CreateButton basePath={basePath} />
            )}
    </aor.CardActions>
);

export default ({ ...props }) => (
    <aor.List
        {...props}
        title="resources.tickets.views.list.title"
        bulkActionButtons={false}
        filters={<Filter />}
        filterDefaultValues={{
            status: TicketEventStatus.ticketTobeAssignedOrInPRogress,
            installation_types_by_company_id: true
        }}
        sort={{ field: "last_updated_status_at", order: "DESC" }}
        actions={<RolesActions />}
    >
        <aor.Datagrid>
            <StatusChip
                source="status"
                translationRoot={"resources.tickets.status"}
                alwaysOn={true}
            />
            <aor.TextField
                source="installation_type_label"
                label="resources.installations.fields.installation_type_id"
            />
            <MyActivityField label="Attività" />
            {!getPolicies().includes(POLICY_TICKETS.SAFE_CREATE) && (
                <aor.ReferenceField
                    sortable={false}
                    source="company_id"
                    reference="companies"
                    linkType="show"
                >
                    <MyChipField source="name" {...props} />
                </aor.ReferenceField>
            )}
            <aor.ReferenceField
                sortable={false}
                source="customer_id"
                reference="customers"
                linkType={false}
            >
                <aor.TextField source="name" />
            </aor.ReferenceField>
            {!getPolicies().includes(POLICY_TICKETS.SAFE_CREATE) && (
                <aor.ReferenceField
                    sortable={false}
                    source="user_id"
                    reference="users"
                    linkType={false}
                    allowEmpty
                >
                    <aor.TextField source="username" />
                </aor.ReferenceField>
            )}
            <aor.ReferenceField
                sortable={false}
                source="installation_id"
                reference="installations"
                linkType="show"
                allowEmpty
            >
                <aor.TextField source="access_url" />
            </aor.ReferenceField>
            <aor.DateField
                source="created_at"
                showTime={false}
                options={{ hour12: false }}
            />
            <aor.DateField
                source="last_updated_status_at"
                showTime={false}
                options={{ hour12: false }}
            />
            {getPolicies() && getPolicies().includes(POLICY_TICKETS.UPDATE) && (
                <aor.EditButton label="resources.tickets.actions.edit_ticket" />
            )}
        </aor.Datagrid>
    </aor.List>
);



// WEBPACK FOOTER //
// ./src/resources/Tickets/List.js